/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function CloudSnow(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M88,92a68,68,0,1,1,68,68H76A44,44,0,1,1,90.30583,74.37792"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Circle cx={76} cy={196} r={8} />
      <Circle cx={116} cy={212} r={8} />
      <Circle cx={164} cy={196} r={8} />
      <Circle cx={68} cy={236} r={8} />
      <Circle cx={156} cy={236} r={8} />
    </Svg>
  );
}

export default CloudSnow;
